export default __webpack_public_path__ + "static/media/015-crocodile.27e773b0.svg";